// i18nOverrides.js

export const enI18n = {
    "primaryauth.username.placeholder": "Email Address",
    "errors.E0000004": "Invalid username or password. Please try again.",
    "password.forgot.email.or.username.placeholder": "Email Address",
    "password.forgot.email.or.username.tooltip": " ",
    "password.forgot.emailSent.title": "Thank you!",
    "password.forgot.emailSent.desc":
        "If the email address {0} is associated with a Freedom web account, you should receive an email shortly containing instructions for resetting your password. If you do not receive an email within a few minutes, please contact servicedeskwsale@freedommortgage.com for assistance.",
    "error.auth.lockedOut":
        "Your account is locked. Please check your email for additional information.",
    "errors.E0000001": "Please enter a valid email address."
};